import * as React from "react";
import { SVGProps } from "react";
const SvgLogoTwillo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-twillo_svg__a)" fill="#CF272D">
      <path d="M9 15.646A6.628 6.628 0 1 1 9 2.389a6.628 6.628 0 0 1 0 13.257ZM9 .018a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z" />
      <path d="M9.37 6.776a1.871 1.871 0 1 1 3.743 0 1.871 1.871 0 0 1-3.743 0Zm0 4.483a1.871 1.871 0 1 1 3.743 0 1.871 1.871 0 0 1-3.743 0Zm-4.483 0a1.872 1.872 0 1 1 3.743 0 1.872 1.872 0 0 1-3.743 0Zm0-4.483a1.871 1.871 0 1 1 3.743 0 1.871 1.871 0 0 1-3.743 0Z" />
    </g>
    <defs>
      <clipPath id="logo-twillo_svg__a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoTwillo;
